<div class="progress__container">
  <nz-progress class="completeness" [nzPercent]="profilePercentage" nzSize="default"></nz-progress>
</div>
